<template>
    <tr :class="{negative: is_failed, positive: is_checked}">
        <td>
            <div v-if="is_failed" class="ui basic negative icon button" :data-tooltip="status" v-popup>
                <i class="remove icon"></i>
            </div>
            <div v-else>
                <div v-if="is_processing" class="ui basic icon button" :data-tooltip="status" v-popup>
                    <i class="notched circle loading icon"></i>
                </div>
                <div v-else>
                    <div v-if="is_checked">
                        <div v-if="is_uploaded" class="ui positive icon button" :data-tooltip="status" v-popup>
                            <i class="icon checkmark box"></i>
                        </div>
                        <div v-else class="ui basic positive icon button" :data-tooltip="status" v-popup>
                            <i class="icon checkmark thin"></i>
                        </div>
                    </div>
                    <div v-else class="ui basic icon button" :data-tooltip="status" v-popup>
                        <i class="icon square outline"></i>
                    </div>
                </div>
            </div>
        </td>
        <td v-for="(conversion, index) in conversions" :data-column="index + 1" :class="{
            error: !column_verification(conversion)}.validated">
            <span v-html="column_verification(conversion).content"></span>
        </td>
    </tr>
</template>

<script>
var ValidatorModule = require('../../.assets/javascripts/waybill_validator.js')
var Validator = new ValidatorModule()

export default {
    name: "UploaderWaybill",
    props: {
        conversions: Array,
        waybill_raw_data: Object,
        group: String
    },
    data() {
        return {
            is_checked: false,
            is_uploaded: false,
            is_processing: false,
            is_failed: false,
            status: "準備"
        }
    },
    mounted() {
    },
    computed: {
        current_scope() {
            return this.$store.state.current_scope
        },
        current_scoped_store() {
            return this.$store.state[this.current_scope]
        },
        validator() {
            return this.current_scoped_store.uploader_module.validator
        },
        required_columns() {
            return _.filter(this.waybill_raw_data.requiring_columns, (e) => {
                return e.status == "required"
            })
        },
        unknown_material_columns() {
            return _.filter(this.waybill_raw_data.requiring_columns, (e) => {
                return e.status == "unknown_material"
            })
        },
        required_attributes() {
            return _.map(this.required_columns, 'attribute_name')
        },
        unknown_material_attributes() {
            return _.map(this.unknown_material_columns, 'attribute_name')
        },
    },
    methods: {
        // 前端驗證方式
        async frontend_validation() {
            var validated = true
            // for(let required_column of this.required_columns) {
            //     await new Promise(resolve => {
            //         var conversion = _.find(this.conversions, (e) => {
            //             return e.attribute_name == required_column.attribute_name
            //         })
            //         if (this.current_scoped_store.uploader_module.requester_node["default_" + conversion.attribute_name]) {
            //         } else {
            //             validated = false
            //             var prefix = this.waybill_raw_data[this.conversions[0].attribute_name] || this.waybill_raw_data[this.conversions[1].attribute_name] || this.waybill_raw_data[this.conversions[2].attribute_name] || "不明"
            //             this.$bus.$emit(this.group + 'add_errors', prefix + "運單驗證失敗: 缺少" + conversion.header_text)
            //         }
            //         resolve()
            //     })
            // }

            await new Promise(resolve => {
                if (validated) {
                    this.is_failed = false
                    this.is_checked = true
                    // this.status = "欄位檢查成功"
                    this.status = this.$t('ui.pages.uploader.field_data_succeeded')
                    this.$bus.$emit(this.group + 'add_checked_count')
                } else {
                    this.is_failed = true
                    this.is_checked = false
                    this.status = false
                }
                resolve()
            })

            await new Promise(resolve => {
                this.is_processing = false
                this.$bus.$emit(this.group + 'add_complete_count')
                resolve()
            })
        },
        column_verification(conversion) {
            if (this.required_attributes.includes(conversion.attribute_name)) {
                if (this.current_scoped_store.uploader_module.requester_node["default_" + conversion.attribute_name]) {
                    return {
                        validated: true,
                        content: this.current_scoped_store.uploader_module.requester_node["default_" + conversion.attribute_name],
                    }
                } else {
                    return {
                        validated: false,
                        // content: '<i class="attention icon"></i>必填欄位',
                        content: '<i class="attention icon"></i>'+this.$t('ui.pages.uploader.column_verification.required_field'),
                    }
                }
            } else if (this.unknown_material_attributes.includes(conversion.attribute_name)) {
                return {
                    validated: false,
                    // content: '<i class="help circle icon"></i>不明運單',
                    content: `<i class="help circle icon"></i>${this.$t('ui.pages.uploader.column_verification.unknown_waybill')}`,
                }
            } else {
                return {
                    validated: true,
                    content: this.waybill_raw_data[conversion.attribute_name],
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
